const WEB_REQUEST = "WEB_REQUEST";
const WEB_FETCH = "WEB_FETCH";
const WEB_ERROR = "WEB_ERROR";

export {
    WEB_REQUEST,
    WEB_FETCH,
    WEB_ERROR
}